import React from 'react';
import { WithNavigationFrame as NotFound } from '~/components/404';
import Nylas from './Nylas';
import DHRouter from '~/components/DHRouter';

import withErrorBoundary from '~/ErrorBoundary';
import ErrorScreen from '~/scenes/ErrorScreen';
import Catalog from '~/Catalog';
import { RouteComponentProps } from '@reach/router';

type Props = RouteComponentProps;
const External: React.FC<Props> = () => (
  <DHRouter>
    <Nylas path={'nylas/*'} />
    <NotFound default />
  </DHRouter>
);

export default withErrorBoundary<Props>(
  External,
  <ErrorScreen explanation={Catalog.genericUnknownErrorMessage} />,
);
